import { render } from "./OutlineResources.vue?vue&type=template&id=15174788"
import script from "./OutlineResources.vue?vue&type=script&lang=js"
export * from "./OutlineResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__